// ===========================

// Create new file: src/pages/ResetPasswordPage.jsx

import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import ResetPasswordForm from '../components/auth/ResetPasswordForm';

const ResetPasswordPage = () => {
  return (
    <Box sx={{ py: 8, minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
      <Container maxWidth="sm">
        <Box sx={{ mb: 4, textAlign: 'center' }}>
          <Typography variant="h4" component="h1" color="primary" sx={{ fontWeight: 700, mb: 2 }}>
            XAUPilot
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Smart Trading Signals, Delivered Instantly
          </Typography>
        </Box>
        
        <ResetPasswordForm />
      </Container>
    </Box>
  );
};

export default ResetPasswordPage;